// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"jgp-2j_K3","icon":"jgp-1FoXK","iconSmall":"jgp-zVE4X"};